import React from 'react'
import Skeleton from '@mui/lab/Skeleton'
import MobileScreen from 'mobile/components/MobileScreen'

import SearchFields from './SearchFields'

const MyOrdersSkeleton = () => {
  return (
  <MobileScreen
    title="Contacts"
    titleIcon="contacts"
    CollapsableSearchComponent={SearchFields}
  >
    <div style={{ width: '100%' }}>
      <Skeleton animation="wave" variant="rect" width="100%" height="250" />
    </div>
  </MobileScreen>
)}

export default MyOrdersSkeleton